export default "__VITE_ASSET__D61xaK1t__"